module.exports = __webpack_public_path__ + "static/media/logo-quiz-vacances.d32870ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-quiz-vacances.png
// module id = 101
// module chunks = 0